import axios from 'axios';
import Auth from '@/utils/auth';

const api = axios.create({
	baseURL: '/api/v1',
	withCredentials: true,
	headers: {
		common: {
			'Access-Control-Allow-Origin': '*'
		}
	}
});

api.interceptors.response.use(response => response, error => {
	const status = error?.response?.status;

	if (status === 403 && location.href !== '/403') {
		location.href = '/403';
	}

	if (status === 401) {
		Auth.relogin();
	}

	return Promise.reject(error);
});

export default api;
